/**
 * Legal Links Constants
 *
 * Central location for legal and compliance-related URLs.
 * Used across the application for Terms of Service and Privacy Policy links.
 */

export const TERMS_OF_SERVICE_URL = "https://alterbiota.com/terms";
export const PRIVACY_POLICY_URL = "https://alterbiota.com/privacy/";
export const COOKIE_POLICY_URL = "/cookie-policy";

/**
 * Bump this version when the cookie policy changes materially
 * (new cookie category, new third-party service, etc.).
 * The consent banner will re-appear for users whose stored version
 * is older than this value.
 */
export const COOKIE_POLICY_VERSION = "2.0";
